import { axios } from '@/utils/request'

const api = {
  switchDemo: '/sso/subjectService/switchDemo', // DEMO环境切换，自动登录演示环境账号
  switchSystemCode: '/sso/subjectService/switchSystemCode', // 切换系统
  queryDeployStatusPlus: '/sso/subjectService/queryDeployStatusPlus', // 查询sellerkit部署中项目进度
  openFreePackage: '/sso/subjectService/openFreePackage', // 注册用户直接开通免费版套餐
  queryEjectFreePackage: '/sso/subjectService/queryEjectFreePackage', // 查询首次注册后免费注册erp的弹窗
  querySystemServicePackageInfo: '/sso/subjectService/querySystemServicePackageInfo', // 获取指定系统购买套餐信息
  authEdm: '/sso/subjectService/authEdm', // EBM系统授权
  queryLiteGuideInfo: '/sso/subjectService/queryLiteGuideInfo', // 查询引导进度
  updateLiteGuide: '/sso/subjectService/updateLiteGuide' // 引导进度收起/关闭状态写入
}

export const switchDemo = async params => axios.post(api.switchDemo, params)
export const switchSystemCode = async params => axios.post(api.switchSystemCode, params)
export const queryDeployStatusPlus = async params => axios.post(api.queryDeployStatusPlus, params)
export const openFreePackage = async params => axios.post(api.openFreePackage, params)
export const queryEjectFreePackage = async params => axios.post(api.queryEjectFreePackage, params)
export const querySystemServicePackageInfo = async params => axios.post(api.querySystemServicePackageInfo, params)
export const authEdm = async params => axios.post(api.authEdm, params)
export const queryLiteGuideInfo = async params => axios.post(api.queryLiteGuideInfo, params)
export const updateLiteGuide = async params => axios.post(api.updateLiteGuide, params)

export default api
